export default __webpack_public_path__ + "114d5ea57b2773ed3224d13a3c60e2b8.svg";